import { render, staticRenderFns } from "./Aneel6.vue?vue&type=template&id=5a86ceda&"
import script from "./Aneel6.vue?vue&type=script&lang=js&"
export * from "./Aneel6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports